import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentRelatorios from './ContentRelatorios';

const Relatorios = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentRelatorios />
      <Bottom />
    </div>
  );
};

export default Relatorios;
